export default function ActionBox({text, value, bgColorClass, icon, action, actionText}){



    return (

        <div className={["small-box", bgColorClass].join(" ")}>
            <div className="inner">
                <h4>{value}</h4>

                <p>{text}</p>
            </div>
            <div className="icon">
                <i className={icon}></i>
            </div>
            <a href="#" className="small-box-footer" onClick={action}>{actionText} <i class="fas fa-arrow-circle-right"></i></a>
        </div>
    );


}